import { VariantProps, cva } from 'class-variance-authority';

export const textButton = cva(['inline-flex items-center space-x-4'], {
  variants: {
    intent: {
      standard: [
        'text-info300',
        'hover:text-info400',
        'active:text-info500',
        'disabled:text-grayscale300',
        'fill-info300',
        'hover:fill-info400',
        'active:fill-info500',
        'disabled:fill-grayscale300',
      ],
      critical: [
        'text-error300',
        'hover:text-error400',
        'active:text-error500',
        'disabled:text-grayscale300',
        'fill-error300',
        'hover:fill-error400',
        'active:fill-error500',
        'disabled:fill-grayscale300',
      ],
    },
    size: {
      tiny: [],
      small: [],
      default: [],
    },
  },
  defaultVariants: {
    intent: 'standard',
    size: 'default',
  },
});

export type TextButtonVariants = VariantProps<typeof textButton>;
